export const itemTypes = [
  'Cup',
  'Lid',
  'Clamshell',
  'Plate',
  'Bowl',
  'Utensil',
];

export const InventoryReportTypeMap: Record<number, string> = {
  0: 'Event (No Inventory)',
  1: 'Monthly (Beg & End Inv)',
  2: 'First Report (Beginning = 0)',
  3: 'Final Report (Ending = 0)',
};

export const InventoryReportStatusMap: Record<number, string> = {
  0: 'Scheduled',
  1: 'Counts Entered',
  2: 'Pending Counts',
  3: 'Ready for Report',
  4: 'Done',
};
